module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Dissection of Life Poetry")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#december"
    }
  }, [_vm._v("December")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#home-on-the-plane"
    }
  }, [_vm._v("Home on the Plane")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#halloween"
    }
  }, [_vm._v("Halloween")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#hospital-redemption"
    }
  }, [_vm._v("Hospital Redemption")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#deaths-not-over"
    }
  }, [_vm._v("Death’s Not Over")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#help-us-kiddies"
    }
  }, [_vm._v("Help Us, Kiddies")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#bleeding-red"
    }
  }, [_vm._v("Bleeding Red")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#natures-patients"
    }
  }, [_vm._v("Natures’ Patients")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#forgive-forget-fulfil"
    }
  }, [_vm._v("Forgive, Forget, Fulfil")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#all-but-won"
    }
  }, [_vm._v("All but Won")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#the-peaceful-reality"
    }
  }, [_vm._v("The Peaceful Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch016#birthday-for-a-friend"
    }
  }, [_vm._v("Birthday for a Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#black-lives-matter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Lives Matter")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#fear-of-triumph",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fear of Triumph")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#frozen-rose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Rose")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#holding-on-letting-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holding On, Letting Go")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-one-that-got-away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The One That Got Away")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#dissolve-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dissolve Me")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-way-her-shadow-smiles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way Her Shadow Smiles")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hope")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#looking-for-a-chance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking for a Chance")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#let-go-the-sorrow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let Go the Sorrow")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#the-bear-she-held",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear She Held")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#shes-not-arrived-yet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("She’s Not Arrived Yet")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#keep-the-earth-alive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep the Earth Alive")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#medical-music",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medical Music")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#another-year",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Year")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#bunny-land",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bunny Land")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#money-doesnt-make-you-well",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Money Doesn’t Make You Well")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#summer-south-africa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer South Africa")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#be-humble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Humble")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#the-demon-inside",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Demon Inside")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#mothers-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother’s Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#inner-peace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inner Peace")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#the-music",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Music")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#educational-influence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Educational Influence")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#dont-look-back-into-your-grave",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Look Back into Your Grave")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#death",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#deciphering-her",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deciphering Her")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#fragility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fragility")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#the-swan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Swan")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#alcohol",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alcohol")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#st-patricks-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St Patrick’s Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#get-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Up")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#hippie-generation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hippie Generation")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#in-regards-to-research",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Regards to Research")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#the-bush",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bush")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#sunday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#painful-planet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painful Planet")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#call-of-the-ancestors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call of the Ancestors")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#obituary-for-a-fairy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obituary for a Fairy")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#barrel-of-suicide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barrel of Suicide")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#wind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#valentines-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valentine’s Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#the-wonder-of-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wonder of Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#my-fairy-walk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Fairy Walk")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#wishing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wishing")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#only-home-weve-got",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Only Home We’ve Got")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#depression-isnt-your-fault",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Depression Isn’t Your Fault")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#the-girl-that-he-once-knew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girl That He Once Knew")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#live-as-you-are",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Live as You Are")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#emerald-isle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emerald Isle")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#footsteps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footsteps")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#chains-of-the-butterflies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chains of the Butterflies")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#the-details-of-snow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Details of Snow")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#a-man-of-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Man of ’91")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#dont-panic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Panic")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#another-year-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Year")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#goodbye-south-africa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goodbye, South Africa")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#a-very-special-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Very Special Christmas")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#love-in-all-its-essence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love in All Its Essence")])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#for-granny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Granny")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#understanding-the-addicts-difference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding the Addict’s Difference")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#driven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Driven")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#someday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Someday")])]), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch082#for-france",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For France")])]), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch083#importance-of-share",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Importance of Share")])]), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch084#regarding-the-solution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regarding the Solution")])]), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch085#rip-my-overseas-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RIP, My Overseas Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch086#difficult-for-some-on-fathers-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Difficult for Some on Father’s Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch087#for-tyler",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Tyler")])]), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch088#forgiveness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgiveness")])]), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch089#room-with-a-view",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Room with a View")])]), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch090#tiny-baby-big-eyes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiny Baby Big Eyes")])]), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch091#the-rose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rose")])]), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch092#life-waits-for-none",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Waits for None")])]), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch093#we-all-end-up-in-wind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We All End Up in Wind")])]), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch094#the-drinker-needs-your-smile",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drinker Needs Your Smile")])]), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch095#autistic-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autistic Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch096#easter-for-the-kiddies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter for the Kiddies")])]), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch097#follow-your-dreams",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Follow Your Dreams")])]), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch098#miss-no-more",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss No More")])]), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch099#a-poem-for-a-dog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Poem for a Dog")])]), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch100#birthday-for-mom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birthday for Mom")])]), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch101#poem-for-the-new-year",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem for the New Year")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0